import {
  FIELD_PREFIXES_MAP,
  DEFAULT_PROPERTIES_MAP,
  LOADING_STATE_MAP
} from './constants';
import {
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_MULTI_LINE_TEXT,
  FIELD_TYPE_TEXT,
  FIELD_TYPE_RECTANGLE,
  FIELD_TYPE_CIRCLE,
  FIELD_TYPE_SAFE_ZONE,
  FIELD_TYPE_PRODUCT_IMAGE,
  FIELD_TYPE_STATIC_TEXT,
  FIELD_TYPE_STATIC_IMAGE,
  FIELD_TYPE_UPLOAD_IMAGE,
  FIELD_TYPE_IMAGE_LIST,
  FIELD_TYPE_IMAGE_LIST_GROUP,
  FIELD_TYPE_SMART_OBJECT,
  FIELD_TYPE_HTML,
  FIELD_TYPE_ADDITIONAL_HTML_TABLE,
  FIELD_TYPE_UPC_GTIN,
  FIELD_TYPE_PRODUCT_DIMENSIONS,
  FIELD_TYPE_LINE,
  FIELD_TYPE_OUTLINE,
  FIELD_TYPE_TEMPLATE_GUIDELINES,
  FIELD_TYPE_CUT_LINE,
  FIELD_TYPE_ICONS,
  FIELD_TYPE_LIST_NUMBERED_CIRCLE,
  FIELD_TYPE_LIST_NUMBERED_SQUARE,
  FIELD_TYPE_LIST_CHECKMARK,
  FIELD_TYPE_LIST_STAR,
  FIELD_TYPE_LIST_ALL
} from "@frontend/constants/type-fields-of-template";
import { drawAdditionalHtmlTable } from "@/common/preview/draw-additional-html-table";
import { 
  addBackgroundThemeImage,
  DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES,
  DEFAULT_TEXT_FIELD_PROPERTIES,
  DEFAULT_STATIC_TEXT_FIELD_PROPERTIES,
  DEFAULT_STATIC_IMAGE_FIELD_PROPERTIES,
  DEFAULT_UPLOAD_IMAGE_FIELD_PROPERTIES,
  DEFAULT_IMAGE_LIST_FIELD_PROPERTIES,
  DEFAULT_SMART_OBJECT_FIELD_PROPERTIES,
  DEFAULT_HTML_FIELD_PROPERTIES,
  DEFAULT_UPC_GTIN_FIELD_PROPERTIES,
  DEFAULT_PRODUCT_DIMENSIONS_FIELD_PROPERTIES,
  DEFAULT_LINE_FIELD_PROPERTIES,
  DEFAULT_OUTLINE_FIELD_PROPERTIES,
  DEFAULT_TEMPLATE_GUIDELINES_FIELD_PROPERTIES,
  DEFAULT_CUT_LINE_PROPERTIES,
  DEFAULT_ICONS_FIELD_PROPERTIES,
  DEFAULT_LIST_FIELD_PROPERTIES
} from "@frontend/group/modules/additional-fields";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
import {editorControlEventBroker, EVENTS} from "@frontend/group/modules/editor-control-popup/event-broker";
import {stripRuntimeImageUrlParameters} from "@frontend/lib/fabric-helper";
const getScopePage = () => ShowPageScopeCollector.get(['updateLayoutChanges']);
export default {
  computed: {
    canBeDuplicated() {
      if (!this.target) return false;
      let fieldType = _.get(this.target, 'fieldType');
      if (!fieldType) {
        fieldType = this.selectedInstance?.template?.fields?.find(field => field.id === this.target.fieldId)?.type;
        if (!fieldType) return false;
      }

      if (typeof fieldType !== 'string') {
        return false;
      }
      
      return Object.keys(FIELD_PREFIXES_MAP).includes(fieldType);
    }
  },
  methods: {
    async handleDuplicateSelectedLayer() {
      try {
        this.isDuplicating = true;
        const activeObjects = this.selectedInstance.canvas.getActiveObjects();
        if (!activeObjects.length) return;
        // detecting object type
        const object = activeObjects[0];
        if (!object.fieldType && object.fieldId) {
          // trying to read it from template
          const template = this.selectedInstance.template;
          if (template && template.fields) {
            const field = template.fields.find(field => field.id === object.fieldId);
            if (field) {
              console.log('Field type found in template', field);
              object.fieldType = field.type;
            } else {
              console.warn('Field type not found in template for object', object);
              return;
            }
          } else {
            console.warn('Template not found or does not have fields');
            return;
          }
        }

        switch (object.fieldType) {
          case FIELD_TYPE_BACKGROND_THEME_IMAGE:
            await this.duplicateBackgroundThemeImage(object)
            break;
          case FIELD_TYPE_PRODUCT_IMAGE: 
            await this.handleDuplicateSelectedProductImage(this.selectedInstance.id);
            break;
          case FIELD_TYPE_TEXT:
          case FIELD_TYPE_MULTI_LINE_TEXT:
            await this.duplicateTexLayer(object)
            break;
          case FIELD_TYPE_RECTANGLE:
          case FIELD_TYPE_CIRCLE: 
          case FIELD_TYPE_SAFE_ZONE:
            await this.duplicateAdditionalField(object);
            break;
          default:
          // do nothing
        }
       
        this.selectedInstance.canvas.requestRenderAll();
      } catch (e) {
        console.error('Error duplicating layer:', e);
      } finally {
        // finishing
        this.isDuplicating = false;
        $('.loadingOverlay').fadeOut();
      }


    },
    async duplicateTexLayer() {
      const activeObjects = this.selectedInstance.canvas.getActiveObjects();
      if (!activeObjects.length) return;
      // detecting object type
      const object = activeObjects[0];
      // getting all text layers
      const ExistingIds = this.selectedInstance.canvas.getObjects()
        .filter(obj => obj.fieldType === FIELD_TYPE_MULTI_LINE_TEXT)
        .map(obj => obj.element_id);
      // getting current id of text layer
      const currentId = object.element_id.split('_').pop();
      // getting all layer propertiest vrom data
      $('.loadingOverlay').fadeIn();
      $('.loadingOverlay-text').html('Duplicating Text Layer...');
      const textOptions = {};
      for (let key of Object.keys(DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES)) {
        textOptions[key] =  this.selectedInstance.data[object.element_id + key] || DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES[key];
        // special case
        if (key === '_alignment' && !this.selectedInstance.data[object.element_id + key]) {
          textOptions[key] = object.textAlign || 'left';
        }
      }
      textOptions.duplicatedOptions = {}
      // getting text 
      if (object.textLines && object.textLines.length) {
        textOptions.textLines = object.textLines;
      } 
      if (object.text) {
        textOptions.textLines = object.text;
      }

      textOptions.isDuplicate = 1;
      // getting text content
      await this.selectedInstance.canvas.fire('add:additional-field', {
        instanceId: this.selectedInstance.id,
        type: FIELD_TYPE_MULTI_LINE_TEXT,
        options:textOptions,
      });
      const { canvas } = this.selectedInstance;

      const objs = canvas.getObjects();
      const NewTextFieldObject =  objs.filter(obj => {
        return obj.fieldType === FIELD_TYPE_MULTI_LINE_TEXT && !ExistingIds.includes(obj.element_id);
      })[0];
      if (this.selectedInstance.data[object.element_id + '_bounding_data']) {
        const boundingData = JSON.parse(this.selectedInstance.data[object.element_id + '_bounding_data']);
        if (boundingData.left && boundingData.top && boundingData.width && boundingData.height) {
          NewTextFieldObject.set({
            left: boundingData.left,
            top: boundingData.top,
            width: boundingData.width,
            height: boundingData.height,
          });
        }
      }
      // getting new added object by
      NewTextFieldObject.set({
        text: object.text,
        textLines: object.textLines,
      })
      NewTextFieldObject.setCoords();
      
      toastr.success('Multi Line Text Layer duplicated successfully');
      canvas.renderAll()
      canvas.setActiveObject(NewTextFieldObject);
      $('.loadingOverlay').fadeOut();
    },

    async handleDuplicateSelectedProductImage(instanceId) {
      $('.loadingOverlay').fadeIn();
      $('.loadingOverlay-text').html('Duplicating Product Image Layer...');
      const { canvas } = this.selectedInstance;
      const selected = canvas.getActiveObject();
      if (!selected || selected.fieldType !== FIELD_TYPE_PRODUCT_IMAGE) {
        $('.loadingOverlay').fadeOut();

        return;
      }
      let fieldsOrder = this.selectedInstance.canvas.getObjects().filter(obj => obj.fieldType === FIELD_TYPE_PRODUCT_IMAGE)
        .sort((a,b) => {
          const aIndex = parseInt(a.element_id.split('_').pop(), 10);
          const bIndex = parseInt(b.element_id.split('_').pop(), 10);
          return aIndex - bIndex;
        }).map(obj => obj.fileName);
      const fileName = selected.fileName;

      fieldsOrder.push(fileName)

      const fileNames = fieldsOrder.join(' ');
      await this.$store.dispatch('fileBrowserProductSelector/disableMoveProductsMode');
      await canvas.fire('product-images-selector:init-view', instanceId);
      await this.$store.dispatch('fileBrowserProductSelector/enableBrowserMode');
      this.$store.commit('fileBrowserProductSelector/SET_MODE', 1);
      const waitForPickedItem = async (fileId, timeout = 5000) => {
        const start = Date.now();
        return new Promise((resolve, reject) => {
          const check = () => {
            const item = this.pickedItems.find(i => i.fileId === fileId);
            if (item) return resolve(item);
            if (Date.now() - start > timeout) return reject('Timeout waiting for pickedItem');
            setTimeout(check, 100);
          };
          check();
        });
      };

      let pickedItem;
      try {
        pickedItem = await waitForPickedItem.call(this, fileName);
      } catch (e) {
        $('.loadingOverlay').fadeOut();
        return;
      }

      this.pickItem({ ...pickedItem, count: pickedItem.count + 1 });
      canvas.fire('product-images-selector:duplicate-image', {
        instanceId,
        data: {
          fileNames,
          fieldsOrder
        }
      });
      // waiting for finish
      await new Promise(resolve => {
        canvas.once('product-images-selector:images-duplicated', resolve);
      });
      const allObjects = this.selectedInstance.canvas.getObjects();
      const maxIndex = allObjects
        .filter(obj => obj.fieldType === FIELD_TYPE_PRODUCT_IMAGE)
        .reduce((max, obj) => {
          const index = parseInt(obj.element_id.split('_').pop(), 10);
          return isNaN(index) ? max : Math.max(max, index);
        }, 0);
      // filtering objects by fieldType
      const allProductObjects = allObjects.filter(obj =>
        obj.fieldType === FIELD_TYPE_PRODUCT_IMAGE
      );
      const newObject = allProductObjects.find(obj => obj.element_id?.endsWith(`image_${maxIndex}`));
      if (newObject) {
        newObject.set({
          left: selected.left,
          top: selected.top,
          scaleX: selected.scaleX,
          scaleY: selected.scaleY,
          flipX: selected.flipX,
          flipY: selected.flipY,
          angle: selected.angle,
          width: selected.width,
          height: selected.height,
        });
        newObject.setCoords();
        let action = 'scale';
        let value = Math.max(newObject.scaleX, newObject.scaleY);
        this.selectedInstance.canvas.setActiveObject(newObject);
        editorControlEventBroker.fire(EVENTS.IMAGE_CHANGED, {action, value });
      }
      $('.loadingOverlay').fadeOut();
      
      this.renderChanges();
     
     
    },
    async duplicateBackgroundThemeImage() {
      const activeObjects = this.selectedInstance.canvas.getActiveObjects();
      if (!activeObjects.length) return;
      // detecting object type
      const object = activeObjects[0];
      // getting all background theme images
      const ExistingImagesIds = this.selectedInstance.canvas.getObjects()
        .filter(obj => obj.fieldType === FIELD_TYPE_BACKGROND_THEME_IMAGE)
        .map(obj => obj.element_id);
      $('.loadingOverlay').fadeIn();
      $('.loadingOverlay-text').html(LOADING_STATE_MAP[FIELD_TYPE_BACKGROND_THEME_IMAGE].loading);
      // getting image url
      const uploadedImageUrl = stripRuntimeImageUrlParameters(object.getSrc());
      const url = new URL(uploadedImageUrl);
      const params = new URLSearchParams(url.search);
      let file = null;
      if (!params.has('file') && /\/img\/icons\/image\.png/.test(uploadedImageUrl)) {
        // posibly this is an placeholder image
        file = '/img/icons/image.png';
      } else {
        file = `/share?file=${params.get('file').split('&')[0]}`;
      }
      const currentPreview = window.previews.find(preview => preview.id === this.selectedInstance.id);
      const options = {
        currentInstanceId: this.selectedInstance.id,
        currentPreview: currentPreview,
        additional_background_images: file,
        add_bk_img_offset_x: object.left,
        add_bk_img_offset_y: object.top,
        scaleX: object.scaleX,
        scaleY: object.scaleY,
        width: object.originalWidth,
        height: object.originalHeight,
        add_bk_img_is_paste_object: false,
        add_bk_img_is_another_instance: true,
        add_bk_img_flipX: object.flipX,
        add_bk_img_flipY: object.flipY,
        add_bk_img_angle: object.angle,
      }

      // checking shadow
      await addBackgroundThemeImage(options)
      $('.loadingOverlay').fadeIn();
      toastr.success(LOADING_STATE_MAP[FIELD_TYPE_BACKGROND_THEME_IMAGE].toast);
      // finding new added object
      const newObject = this.selectedInstance.canvas.getObjects()
        .find(obj => obj.fieldType === FIELD_TYPE_BACKGROND_THEME_IMAGE && !ExistingImagesIds.includes(obj.id));

      if (newObject) {
        newObject.setCoords();
        this.selectedInstance.canvas.setActiveObject(newObject)
        let action = 'scale';
        let value = Math.max(object.scaleX, object.scaleY);
        editorControlEventBroker.fire(EVENTS.IMAGE_CHANGED, {action, value })
        this.selectedInstance.canvas.requestRenderAll();
      }
    },
    async duplicateAdditionalField(object) {
      const ExistingIds = this.selectedInstance.canvas.getObjects()
        .filter(obj => obj.fieldType === object.fieldType)
        .map(obj => obj.element_id);
      // getting current id of text layer
      const currentId = object.element_id.split('_').pop();
      // getting all layer propertiest from data
      $('.loadingOverlay').fadeIn();
      $('.loadingOverlay-text').html(LOADING_STATE_MAP[object.fieldType].loading);
      const newOptions = {};
      for (let key of Object.keys(DEFAULT_PROPERTIES_MAP[object.fieldType])) {
        newOptions[key] =  this.selectedInstance.data[object.element_id + key] ||
          DEFAULT_PROPERTIES_MAP[object.fieldType][key];
        // case for rectangle
        if (key === '_corners') {
          newOptions[key] = JSON.stringify(object.corners);
        }
        if (key === '_corner_radius' && this.selectedInstance.data[object.element_id + key] === undefined) {
          newOptions[key] = newOptions['_radius'] ?? object.rx;
        }
      }
      
      newOptions["_width"] = object.width;
      newOptions["_height"] = object.height;
      newOptions["_offset_x"] = object.left;
      newOptions["_offset_y"] = object.top;
      // getting properties from field options
      const field = this.selectedInstance.template.fields.find(field => field.id === object.fieldId);
      if (field && field.options) {
        const fieldOptions = JSON.parse(field.options);
      }
      // getting text content
      await this.selectedInstance.canvas.fire('add:additional-field', {
        instanceId: this.selectedInstance.id,
        type: object.fieldType,
        options:newOptions,
      });
      const { canvas } = this.selectedInstance;

      const objs = canvas.getObjects();
      const duplicatedObject =  objs.filter(obj => {
        return obj.fieldType === object.fieldType && !ExistingIds.includes(obj.element_id);
      })[0];
      // setting properties
      if (duplicatedObject) {
        duplicatedObject.set({
          left: object.left,
          top: object.top,
          scaleX: object.scaleX,
          scaleY: object.scaleY,
          flipX: object.flipX,
          flipY: object.flipY,
          angle: object.angle,
          width: object.width,
          height: object.height,
          rx: object.rx,
          ry: object.ry,
        });
        if (newOptions['_corners']) {
          duplicatedObject.corners = JSON.parse(newOptions['_corners']);
        }
        if (newOptions['_corner_radius']) {
          duplicatedObject.cornerSize = newOptions['_corner_radius'];
        }
        duplicatedObject.setCoords();
      }
      // getting new added object by
      toastr.success(LOADING_STATE_MAP[object.fieldType].toast);
      canvas.setActiveObject(duplicatedObject);
    },
    /**
     * This function is used to add the selected layer to all templates
     * @returns {Promise<void>}
     */
    async handleAddingToAllTemplates() {
      try {
        const activeObjects = this.selectedInstance?.canvas?.getActiveObjects();
        const template = this.selectedInstance.template;
        if (!Array.isArray(activeObjects) || activeObjects.length === 0) {
          console.warn('No active objects selected for copying to all templates');
          if (typeof toastr !== 'undefined') {
            toastr.warning('Please select at least one layer to copy to all templates.');
          }
          return;
        }

        const previews = window.previews.filter(item => item.id !== this.selectedInstance.id);
        if (!previews.length) {
          console.warn('No other templates available to copy to');
          if (typeof toastr !== 'undefined') {
            toastr.warning('No other templates available to copy to.');
          }
          return;
        }

        // Show loading overlay
        $('.loadingOverlay').fadeIn();
        $('.loadingOverlay-text').html(`Copying ${activeObjects.length} layer(s) to ${previews.length} template(s)...`);
        
        let successCount = 0;
        let errorCount = 0;
        const totalObjects = activeObjects.length;
        const totalTemplates = previews.length;
        const errors = [];

        for (let i = 0; i < activeObjects.length; i++) {
          const object = activeObjects[i];
          this.isCopying = true;
          
          // Update progress
          const progress = Math.round((i / totalObjects) * 100);
          $('.loadingOverlay-text').html(`Copying layer ${i + 1} of ${totalObjects} to ${totalTemplates} template(s)... ${progress}%`);
          
          // Detect field type if not already set
          if (!object.fieldType && object.fieldId) {
            const template = this.selectedInstance.template;
            if (template && template.fields) {
              const field = template.fields.find(field => field.id === object.fieldId);
              if (field) {
                object.fieldType = field.type;
              }
            }
          }

          // Special handling for smart objects that don't have fieldType
          if (!object.fieldType && object.id && object.id.startsWith('mask_')) {
            object.fieldType = FIELD_TYPE_SMART_OBJECT;
          }

          if (!object.fieldType) {
            const errorMsg = `Object ${object.id || object.name || 'Unknown'} has no fieldType, skipping...`;
            console.warn(errorMsg);
            errors.push(errorMsg);
            errorCount++;
            continue;
          }

          try {
            const instanceId = this.selectedInstance.id;
            console.log(`Copying object ${i + 1}/${totalObjects}: ${object.fieldType} (${object.id || object.name || 'Unknown'})`);
            
            switch (object.fieldType) {
              case FIELD_TYPE_BACKGROND_THEME_IMAGE:
                await this.copyBackgroundThemeImage(object, previews)
                break;
              case FIELD_TYPE_PRODUCT_IMAGE: 
                await this.copyProductImage(object, previews, instanceId);
                break;
              case FIELD_TYPE_TEXT:
              case FIELD_TYPE_MULTI_LINE_TEXT:
              case FIELD_TYPE_STATIC_TEXT:
                await this.copyTextLayer(object, previews)
                break;
              case FIELD_TYPE_RECTANGLE:
              case FIELD_TYPE_CIRCLE: 
              case FIELD_TYPE_SAFE_ZONE:
                await this.copyAdditionalField(object, previews);
                break;
              case FIELD_TYPE_STATIC_IMAGE:
              case FIELD_TYPE_UPLOAD_IMAGE:
              case FIELD_TYPE_IMAGE_LIST:
              case FIELD_TYPE_IMAGE_LIST_GROUP:
                await this.copyImageField(object, previews);
                break;
              case FIELD_TYPE_SMART_OBJECT:
                await this.copySmartObject(object, previews);
                break;
              case FIELD_TYPE_HTML:
                await this.copyHtmlField(object, previews);
                break;
              case FIELD_TYPE_ADDITIONAL_HTML_TABLE:
                await this.copyAdditionalHtmlTableField(object, previews);
                break;
              case FIELD_TYPE_UPC_GTIN:
                await this.copyUpcGtinField(object, previews);
                break;
              case FIELD_TYPE_PRODUCT_DIMENSIONS:
                await this.copyProductDimensionsField(object, previews);
                break;
              case FIELD_TYPE_LINE:
              case FIELD_TYPE_OUTLINE:
              case FIELD_TYPE_CUT_LINE:
                await this.copyLineField(object, previews);
                break;
              case FIELD_TYPE_TEMPLATE_GUIDELINES:
                await this.copyTemplateGuidelinesField(object, previews);
                break;
              case FIELD_TYPE_ICONS:
                await this.copyIconsField(object, previews);
                break;
              case FIELD_TYPE_LIST_NUMBERED_CIRCLE:
              case FIELD_TYPE_LIST_NUMBERED_SQUARE:
              case FIELD_TYPE_LIST_CHECKMARK:
              case FIELD_TYPE_LIST_STAR:
              case FIELD_TYPE_LIST_ALL:
                await this.copyListField(object, previews);
                break;
              default:
                { const errorMsg = `Field type "${object.fieldType}" not supported for copying to all templates`;
                console.warn(errorMsg);
                errors.push(errorMsg);
                errorCount++;
                continue; }
            }
            
            successCount++;
            
          } catch (e) {
            const errorMsg = `Error copying object ${object.id || object.name || 'Unknown'} of type ${object.fieldType}: ${e.message}`;
            console.error(errorMsg, e);
            errors.push(errorMsg);
            errorCount++;
          }
        }

        // Show final results
        if (successCount > 0) {
          const message = errorCount > 0 
            ? `Successfully copied ${successCount} layer(s) to ${totalTemplates} template(s). ${errorCount} layer(s) failed.`
            : `Successfully copied ${successCount} layer(s) to ${totalTemplates} template(s).`;
          
          // Use toastr if available, otherwise console.log
          if (typeof toastr !== 'undefined') {
            toastr.success(message);
          } else {
            console.log(message);
          }
          
          // Log detailed errors if any
          if (errors.length > 0) {
            console.warn('Copy errors:', errors);
          }
        } else {
          const message = 'Failed to copy any layers to templates.';
          if (typeof toastr !== 'undefined') {
            toastr.error(message);
          } else {
            console.error(message);
          }
        }

      } catch (e) {
        console.error('Error copying layer:', e);
        if (typeof toastr !== 'undefined') {
          toastr.error('Failed to copy layers to templates: ' + e.message);
        }
      } finally {
        this.isCopying = false;
        $('.loadingOverlay').fadeOut();
      }
    },
    async copyTextLayer(object, previews) {
      let textOptions = {};
      //copy object properties
      for (let key of Object.keys(DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES)) {
        textOptions[key] =  this.selectedInstance.data[object.element_id + key] || DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES[key];
        if (key === '_alignment' && !this.selectedInstance.data[object.element_id + key]) {
          textOptions[key] = object.textAlign || 'left';
        }
      }
      
      //go through all available templates
      for (const preview of previews) {
        const ExistingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_MULTI_LINE_TEXT)
          .map(obj => obj.element_id);
        
        textOptions.duplicatedOptions = {}
        // getting text 
        if (object.textLines && object.textLines.length) {
          textOptions.textLines = object.textLines;
        } 
        if (object.text) {
          textOptions.textLines = object.text;
        }

        textOptions.isDuplicate = 1;
        // getting text content
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: FIELD_TYPE_MULTI_LINE_TEXT,
          options:textOptions,
        });

        const objs = preview.canvas.getObjects();
        const NewTextFieldObject =  objs.filter(obj => {
          return obj.fieldType === FIELD_TYPE_MULTI_LINE_TEXT && !ExistingIds.includes(obj.element_id);
        })[0];
        if (preview.data[object.element_id + '_bounding_data']) {
          const boundingData = JSON.parse(preview.data[object.element_id + '_bounding_data']);
          if (boundingData.left && boundingData.top && boundingData.width && boundingData.height) {
            NewTextFieldObject.set({
              left: boundingData.left,
              top: boundingData.top,
              width: boundingData.width,
              height: boundingData.height,
            });
          }
        }

        // set cords for the new object
        NewTextFieldObject.set({
          text: object.text,
          textLines: object.textLines,
        })
        NewTextFieldObject.setCoords();

        //render changes for each template
        preview.canvas.renderAll();
      }
    },
    async copyAdditionalField(object, previews) {
      let newOptions = {};
      for (let key of Object.keys(DEFAULT_PROPERTIES_MAP[object.fieldType])) {
        newOptions[key] =  this.selectedInstance.data[object.element_id + key] ||
          DEFAULT_PROPERTIES_MAP[object.fieldType][key];
        // case for rectangle
        if (key === '_corners') {
          newOptions[key] = JSON.stringify(object.corners);
        }
        if (key === '_corner_radius' && this.selectedInstance.data[object.element_id + key] === undefined) {
          newOptions[key] = newOptions['_radius'] ?? object.rx;
        }
      }

      newOptions["_width"] = object.width;
      newOptions["_height"] = object.height;
      newOptions["_offset_x"] = object.left;
      newOptions["_offset_y"] = object.top;
      //go through all available templates
      for (const preview of previews) {
        const ExistingIds = preview.canvas.getObjects()
        .filter(obj => obj.fieldType === object.fieldType)
        .map(obj => obj.element_id);
        
        // getting text content
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: object.fieldType,
          options: newOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject =  objs.filter(obj => {
          return obj.fieldType === object.fieldType && !ExistingIds.includes(obj.element_id);
        })[0];
        // setting properties
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
            rx: object.rx,
            ry: object.ry,
          });
          if (newOptions['_corners']) {
            duplicatedObject.corners = JSON.parse(newOptions['_corners']);
          }
          if (newOptions['_corner_radius']) {
            duplicatedObject.cornerSize = newOptions['_corner_radius'];
          }
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyBackgroundThemeImage(object, previews) {
      //go through all available templates
      for (const preview of previews) {
        // getting all background theme images
        const ExistingImagesIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_BACKGROND_THEME_IMAGE)
          .map(obj => obj.element_id);
        // getting image url
        const uploadedImageUrl = stripRuntimeImageUrlParameters(object.getSrc());
        const url = new URL(uploadedImageUrl);
        const params = new URLSearchParams(url.search);
        let file = null;
        if (!params.has('file') && /\/img\/icons\/image\.png/.test(uploadedImageUrl)) {
          // posibly this is an placeholder image
          file = '/img/icons/image.png';
        } else {
          file = `/share?file=${params.get('file').split('&')[0]}`;
        }
        console.log('this.selectedInstance.id')
        const options = {
          currentInstanceId: preview.id,
          currentPreview: preview,
          additional_background_images: file,
          add_bk_img_offset_x: object.left,
          add_bk_img_offset_y: object.top,
          scaleX: object.scaleX,
          scaleY: object.scaleY,
          width: object.originalWidth,
          height: object.originalHeight,
          add_bk_img_is_paste_object: false,
          add_bk_img_is_another_instance: true,
          add_bk_img_flipX: object.flipX,
          add_bk_img_flipY: object.flipY,
          add_bk_img_angle: object.angle,
        }

        // checking shadow
        await addBackgroundThemeImage(options)
        // finding new added object
        const newObject = preview.canvas.getObjects()
          .find(obj => obj.fieldType === FIELD_TYPE_BACKGROND_THEME_IMAGE && !ExistingImagesIds.includes(obj.id));

        if (newObject) {
          newObject.setCoords();
          let action = 'scale';
          let value = Math.max(object.scaleX, object.scaleY);
          editorControlEventBroker.fire(EVENTS.IMAGE_CHANGED, {action, value })
          preview.canvas.requestRenderAll();
        }
      }
    },
    async copyImageField(object, previews) {
      let imageOptions = {};
      const defaultProperties = this.getDefaultPropertiesForFieldType(object.fieldType);
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        imageOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set image-specific properties
      imageOptions["_width"] = object.width;
      imageOptions["_height"] = object.height;
      imageOptions["_offset_x"] = object.left;
      imageOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === object.fieldType)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: object.fieldType,
          options: imageOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === object.fieldType && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copySmartObject(object, previews) {
      let smartObjectOptions = {};
      const defaultProperties = DEFAULT_SMART_OBJECT_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        smartObjectOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set smart object-specific properties
      smartObjectOptions["_width"] = object.width;
      smartObjectOptions["_height"] = object.height;
      smartObjectOptions["_offset_x"] = object.left;
      smartObjectOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_SMART_OBJECT)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: FIELD_TYPE_SMART_OBJECT,
          options: smartObjectOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === FIELD_TYPE_SMART_OBJECT && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyHtmlField(object, previews) {
      let htmlOptions = {};
      const defaultProperties = DEFAULT_HTML_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        htmlOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set HTML-specific properties
      htmlOptions["_width"] = object.width;
      htmlOptions["_height"] = object.height;
      htmlOptions["_offset_x"] = object.left;
      htmlOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === object.fieldType)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: object.fieldType,
          options: htmlOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === object.fieldType && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyAdditionalHtmlTableField(object, previews) {
      console.log('=== Starting Additional HTML Table Copy ===');
      console.log('Object:', object);
      console.log('Previews:', previews);
      
      // Get the table data from the source object
      const tableData = object.tableData || object.html_table_data;
      console.log('Table data from object:', tableData);
      
      if (!tableData) {
        console.warn('No table data found for Additional HTML Table object');
        return;
      }

      // Extract the table index from the object ID
      const tableIndex = parseInt(object.id.replace('add_html_table_', ''));
      console.log('Table index:', tableIndex);
      
      // Get the current add_html_tables array from the source instance using canvas_data
      const sourceInstanceId = this.selectedInstance.id;
      console.log('Source instance ID:', sourceInstanceId);
      console.log('Window canvas_data:', window.canvas_data);
      
      const sourceTables = window.canvas_data?.[sourceInstanceId]?._data?.add_html_tables || [];
      console.log('Source tables array:', sourceTables);
      
      const sourceTable = sourceTables[tableIndex];
      console.log('Source table at index:', sourceTable);
      
      if (!sourceTable) {
        console.warn(`Table data not found at index ${tableIndex} in source instance ${sourceInstanceId}`);
        console.log('Available indices:', sourceTables.map((_, i) => i));
        return;
      }

      console.log('Source table data to copy:', sourceTable);

      // Go through all available templates
      for (const preview of previews) {
        try {
          console.log('Processing preview:', preview.id);
          
          // Get existing tables in the target preview
          const targetTables = preview.data.add_html_tables || [];
          console.log('Target tables before:', targetTables);
          
          // Add the table data to the target
          const newTables = [...targetTables, sourceTable];
          console.log('New tables array:', newTables);
          
          // Update the target preview's data
          preview.data.add_html_tables = newTables;
          
          // Also update the canvas_data for the target instance
          const targetInstanceId = preview.id;
          if (window.canvas_data?.[targetInstanceId]) {
            window.canvas_data[targetInstanceId]._data.add_html_tables = newTables;
            console.log('Updated canvas_data for target instance');
          } else {
            console.warn('Target instance not found in canvas_data:', targetInstanceId);
          }
          
          // Add the changes to layoutChanges so they get saved
          try {
            const { updateLayoutChanges } = getScopePage();
            if (updateLayoutChanges) {
              updateLayoutChanges(targetInstanceId, 'add_html_tables', newTables);
              console.log('Added table changes to layoutChanges for saving');
            } else {
              console.warn('updateLayoutChanges function not available from getScopePage');
            }
          } catch (error) {
            console.error('Error accessing updateLayoutChanges:', error);
          }
          
          console.log('Updated target data:', preview.data.add_html_tables);
          
          // Trigger the table drawing function
          console.log('Calling drawAdditionalHtmlTable directly...');
          await drawAdditionalHtmlTable({
            canvas: preview.canvas,
            data: preview.data
          });
          console.log('drawAdditionalHtmlTable completed');
          
          // Find the newly added table object
          const newTableObjects = preview.canvas.getObjects()
            .filter(obj => obj.fieldType === FIELD_TYPE_ADDITIONAL_HTML_TABLE);
          
          console.log('Table objects after drawing:', newTableObjects.length);
          
          const newTableObject = newTableObjects[newTableObjects.length - 1];
          
          if (newTableObject) {
            console.log('Found new table object:', newTableObject);
            // Set the position and properties to match the source
            newTableObject.set({
              left: object.left,
              top: object.top,
              scaleX: object.scaleX,
              scaleY: object.scaleY,
              flipX: object.flipX,
              flipY: object.flipY,
              angle: object.angle,
              width: object.width,
              height: object.height,
            });
            newTableObject.setCoords();
            preview.canvas.renderAll();
            console.log('Table object positioned and rendered');
          } else {
            console.warn('No new table object found after drawing');
          }
        } catch (error) {
          console.error('Error copying Additional HTML Table:', error);
        }
      }
      
      console.log('=== Additional HTML Table Copy Completed ===');
    },
    async copyUpcGtinField(object, previews) {
      let upcGtinOptions = {};
      const defaultProperties = DEFAULT_UPC_GTIN_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        upcGtinOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set UPC/GTIN-specific properties
      upcGtinOptions["_width"] = object.width;
      upcGtinOptions["_height"] = object.height;
      upcGtinOptions["_offset_x"] = object.left;
      upcGtinOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_UPC_GTIN)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: FIELD_TYPE_UPC_GTIN,
          options: upcGtinOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === FIELD_TYPE_UPC_GTIN && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyProductDimensionsField(object, previews) {
      let productDimensionsOptions = {};
      const defaultProperties = DEFAULT_PRODUCT_DIMENSIONS_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        productDimensionsOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set product dimensions-specific properties
      productDimensionsOptions["_width"] = object.width;
      productDimensionsOptions["_height"] = object.height;
      productDimensionsOptions["_offset_x"] = object.left;
      productDimensionsOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_PRODUCT_DIMENSIONS)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: FIELD_TYPE_PRODUCT_DIMENSIONS,
          options: productDimensionsOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === FIELD_TYPE_PRODUCT_DIMENSIONS && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyLineField(object, previews) {
      let lineOptions = {};
      const defaultProperties = this.getDefaultPropertiesForFieldType(object.fieldType);
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        lineOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set line-specific properties
      lineOptions["_offset_x"] = object.left;
      lineOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === object.fieldType)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: object.fieldType,
          options: lineOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === object.fieldType && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyTemplateGuidelinesField(object, previews) {
      let templateGuidelinesOptions = {};
      const defaultProperties = DEFAULT_TEMPLATE_GUIDELINES_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        templateGuidelinesOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set template guidelines-specific properties
      templateGuidelinesOptions["_width"] = object.width;
      templateGuidelinesOptions["_height"] = object.height;
      templateGuidelinesOptions["_offset_x"] = object.left;
      templateGuidelinesOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_TEMPLATE_GUIDELINES)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: FIELD_TYPE_TEMPLATE_GUIDELINES,
          options: templateGuidelinesOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === FIELD_TYPE_TEMPLATE_GUIDELINES && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyIconsField(object, previews) {
      let iconsOptions = {};
      const defaultProperties = DEFAULT_ICONS_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        iconsOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set icons-specific properties
      iconsOptions["_width"] = object.width;
      iconsOptions["_height"] = object.height;
      iconsOptions["_offset_x"] = object.left;
      iconsOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === FIELD_TYPE_ICONS)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: FIELD_TYPE_ICONS,
          options: iconsOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === FIELD_TYPE_ICONS && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyListField(object, previews) {
      let listOptions = {};
      const defaultProperties = DEFAULT_LIST_FIELD_PROPERTIES;
      
      // Copy object properties
      for (let key of Object.keys(defaultProperties)) {
        listOptions[key] = this.selectedInstance.data[object.element_id + key] || defaultProperties[key];
      }
      
      // Set list-specific properties
      listOptions["_width"] = object.width;
      listOptions["_height"] = object.height;
      listOptions["_offset_x"] = object.left;
      listOptions["_offset_y"] = object.top;
      
      // Go through all available templates
      for (const preview of previews) {
        const existingIds = preview.canvas.getObjects()
          .filter(obj => obj.fieldType === object.fieldType)
          .map(obj => obj.element_id);
        
        await preview.canvas.fire('add:additional-field', {
          instanceId: preview.id,
          type: object.fieldType,
          options: listOptions,
        });

        const objs = preview.canvas.getObjects();
        const duplicatedObject = objs.filter(obj => {
          return obj.fieldType === object.fieldType && !existingIds.includes(obj.element_id);
        })[0];
        
        if (duplicatedObject) {
          duplicatedObject.set({
            left: object.left,
            top: object.top,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            flipX: object.flipX,
            flipY: object.flipY,
            angle: object.angle,
            width: object.width,
            height: object.height,
          });
          duplicatedObject.setCoords();
          preview.canvas.renderAll();
        }
      }
    },
    async copyProductImage(object, previews, instanceId) {
      for (const preview of previews) {
        try {
          const { canvas } = preview;
          
          const existingProductImages = canvas.getObjects()
            .filter(obj => obj.fieldType === FIELD_TYPE_PRODUCT_IMAGE)
            .sort((a, b) => {
              const aIndex = parseInt(a.element_id.split('_').pop(), 10);
              const bIndex = parseInt(b.element_id.split('_').pop(), 10);
              return aIndex - bIndex;
            });
          
          const fileName = object.fileName;
          if (!fileName) {
            console.warn('Product image object has no fileName, skipping...');
            continue;
          }
          
          let fieldsOrder = existingProductImages.map(obj => obj.fileName);
          fieldsOrder.push(fileName);
          
          const fileNames = fieldsOrder.join(' ');
          
          await this.$store.dispatch('fileBrowserProductSelector/disableMoveProductsMode');
          await canvas.fire('product-images-selector:init-view', preview.id);
          await this.$store.dispatch('fileBrowserProductSelector/enableBrowserMode');
          this.$store.commit('fileBrowserProductSelector/SET_MODE', 1);
          
          let pickedItem = null;
          
          if (this.pickedItems && this.pickedItems.length > 0) {
            pickedItem = this.pickedItems.find(i => i.fileId === fileName);
          }
          
          if (!pickedItem && this.selectedItems && this.selectedItems.length > 0) {
            pickedItem = this.selectedItems.find(i => i.fileId === fileName);
          }
          
          if (!pickedItem && this.items && this.items.length > 0) {
            pickedItem = this.items.find(i => i.fileId === fileName);
          }
          
          if (!pickedItem) {
            console.warn(`Could not find picked item for ${fileName}, attempting to construct from object data`);
            
            const imageUrl = object.getSrc ? object.getSrc() : null;
            if (imageUrl) {
              try {
                const url = new URL(imageUrl);
                const params = new URLSearchParams(url.search);
                const fileParam = params.get('file');
                
                if (fileParam) {
                  pickedItem = {
                    fileId: fileName,
                    fileName: fileName,
                    file: fileParam.split('&')[0],
                    count: 1
                  };
                }
              } catch (urlError) {
                console.warn('Could not parse image URL:', urlError);
              }
            }
          }
          
          if (!pickedItem) {
            console.error(`Could not find or construct picked item for ${fileName} in preview ${preview.id}, skipping...`);
            continue;
          }
          
          try {
            this.pickItem({ ...pickedItem, count: pickedItem.count + 1 });
          } catch (pickError) {
            console.warn('Error picking item, continuing with existing data:', pickError);
          }
          
          canvas.fire('product-images-selector:duplicate-image', {
            instanceId: preview.id,
            data: {
              fileNames,
              fieldsOrder
            }
          });
          
          const duplicationPromise = new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
              reject(new Error(`Timeout waiting for product image duplication in preview ${preview.id}`));
            }, 10000);
            
            canvas.once('product-images-selector:images-duplicated', () => {
              clearTimeout(timeout);
              resolve();
            });
          });
          
          try {
            await duplicationPromise;
          } catch (timeoutError) {
            console.error(`Duplication timeout for preview ${preview.id}:`, timeoutError);
            continue;
          }
          
          const allObjects = canvas.getObjects();
          const maxIndex = allObjects
            .filter(obj => obj.fieldType === FIELD_TYPE_PRODUCT_IMAGE)
            .reduce((max, obj) => {
              const index = parseInt(obj.element_id.split('_').pop(), 10);
              return isNaN(index) ? max : Math.max(max, index);
            }, 0);
          
          const allProductObjects = allObjects.filter(obj =>
            obj.fieldType === FIELD_TYPE_PRODUCT_IMAGE
          );
          
          const newObject = allProductObjects.find(obj => obj.element_id?.endsWith(`image_${maxIndex}`));
          
          if (newObject) {
            newObject.set({
              left: object.left,
              top: object.top,
              scaleX: object.scaleX,
              scaleY: object.scaleY,
              flipX: object.flipX,
              flipY: object.flipY,
              angle: object.angle,
              width: object.width,
              height: object.height,
            });
            canvas.setActiveObject(newObject);
            newObject.setCoords();
            
            let action = 'scale';
            let value = Math.max(newObject.scaleX, newObject.scaleY);
            editorControlEventBroker.fire(EVENTS.IMAGE_CHANGED, {action, value });
            
            canvas.renderAll();
          } else {
            console.warn(`Could not find newly added product image object in preview ${preview.id}`);
          }
          
        } catch (error) {
          console.error(`Error copying product image to preview ${preview.id}:`, error);
        }
      }
    },
    // Helper method to get default properties for a field type
    getDefaultPropertiesForFieldType(fieldType) {
      const propertiesMap = {
        [FIELD_TYPE_STATIC_IMAGE]: DEFAULT_STATIC_IMAGE_FIELD_PROPERTIES,
        [FIELD_TYPE_UPLOAD_IMAGE]: DEFAULT_UPLOAD_IMAGE_FIELD_PROPERTIES,
        [FIELD_TYPE_IMAGE_LIST]: DEFAULT_IMAGE_LIST_FIELD_PROPERTIES,
        [FIELD_TYPE_IMAGE_LIST_GROUP]: DEFAULT_IMAGE_LIST_FIELD_PROPERTIES,
        [FIELD_TYPE_LINE]: DEFAULT_LINE_FIELD_PROPERTIES,
        [FIELD_TYPE_OUTLINE]: DEFAULT_OUTLINE_FIELD_PROPERTIES,
        [FIELD_TYPE_CUT_LINE]: DEFAULT_CUT_LINE_PROPERTIES,
        [FIELD_TYPE_ADDITIONAL_HTML_TABLE]: DEFAULT_HTML_FIELD_PROPERTIES,
      };
      return propertiesMap[fieldType] || {};
    }
  }
}
